var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-bottom":"0.1rem"}},[_c('el-col',{attrs:{"span":24}},_vm._l((_vm.companyCountData),function(item,index){return _c('span',{key:index,staticClass:"count-span"},[_vm._v("\n        "+_vm._s(item.label)+":"+_vm._s(item.value)+"\n      ")])}),0)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74fa975f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/company_risks/common/CompanyRisksCount.vue
// module id = null
// module chunks = 